import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询本组织的数字房型列表
export const queryDigitalRooms: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalRooms', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/data/design/blankroom/searchdigitalroom', payload);
    commit('setDigitalRooms', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setDigitalRooms', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 编辑数字房型
export const editDigitalRoom: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/v1/design/blankroom/modify', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 发布或下架数字房型
export const publishDigitalRoom: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    const success: boolean = await $http.post('/v1/design/blankroom/shelfdigitalroom', payload);
    const operateText = payload.operate ? '发布' : '下架';
    const statusText = success ? '成功' : '失败';
    store.commit('common/setToast', { visible: true, text: operateText + statusText });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 删除数字房型
export const deleteDigitalRoom: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/design/blankroom/deletedigitalroom', payload);
    store.commit('common/setToast', { visible: true, text: '删除成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};
